import { createFileRoute } from '@tanstack/react-router'
import { ConnectionEditor } from './-ConnectionEditor'

export const Route = createFileRoute('/settings/integrations/connections/$id')({
  component: EditConnectionPage,
})

function EditConnectionPage() {
  const { id } = Route.useParams()
  return <ConnectionEditor key={id} id={id} />
}
